import { STRING_ACCESS_TOKEN_COMPRARTODO } from "../utils/const/string-const";

import { SHARED_MISSING_BEARER_TOKEN_MESSAGE } from "../utils/shared-functions";

const HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const getHeaders = (token = true) => {
  if (token === true) {
    const bearer = localStorage.getItem(STRING_ACCESS_TOKEN_COMPRARTODO);
    if (typeof bearer !== "string") throw new Error(SHARED_MISSING_BEARER_TOKEN_MESSAGE);
    return {
      ...HEADERS,
      Authorization: `Bearer ${bearer}`,
    };
  }
  if (token === false) {
    return {
      ...HEADERS,
    };
  }
};